import qs from 'query-string';
import { isString } from 'lodash';

/**
 * Reads `actionId` from the current URL search string.
 * keywords: deep link, actionId, query param
 */
const getActionIdFromUrl = (
  search: string = global.window?.location?.search || '',
): string | null => {
  const { actionId } = qs.parse(search);
  return isString(actionId) && actionId.length > 0 ? actionId : null;
};

export default getActionIdFromUrl;
